export interface InputGuards {
  sanitizeText: (text: string) => string;
  handleKeydown: (event: KeyboardEvent) => void;
  resolvePaste: (event: ClipboardEvent, currentValue: string) => string;
}

export function createInputGuards(allowedChar: RegExp, disallowedChars: RegExp): InputGuards {
  function sanitizeText(text: string): string {
    return text.replace(disallowedChars, '');
  }

  function handleKeydown(event: KeyboardEvent): void {
    if (
      event.ctrlKey ||
      event.metaKey ||
      event.altKey ||
      event.key.length > 1 ||
      allowedChar.test(event.key)
    ) {
      return;
    }

    event.preventDefault();
  }

  function resolvePaste(event: ClipboardEvent, currentValue: string): string {
    event.preventDefault();

    const pasted = sanitizeText(event.clipboardData?.getData('text') ?? '');
    const input = event.target as HTMLInputElement | null;
    const start = input?.selectionStart ?? currentValue.length;
    const end = input?.selectionEnd ?? currentValue.length;

    return currentValue.slice(0, start) + pasted + currentValue.slice(end);
  }

  return { sanitizeText, handleKeydown, resolvePaste };
}

const prefixGuards = createInputGuards(/^[0-9.]$/, /[^0-9.]/g);
const revisionGuards = createInputGuards(/^[0-9.]$/, /[^0-9.]/g);

export const sanitizePrefixText = prefixGuards.sanitizeText;
export const handlePrefixKeydown = prefixGuards.handleKeydown;
export const resolvePrefixPaste = prefixGuards.resolvePaste;

export const sanitizeRevisionText = revisionGuards.sanitizeText;
export const handleRevisionKeydown = revisionGuards.handleKeydown;
export const resolveRevisionPaste = revisionGuards.resolvePaste;
